import api from './api'

export const INVENTORY_INIT_REQUEST = 'inventory/INVENTORY_INIT/REQUEST';
export const INVENTORY_INIT_SUCCESS = 'inventory/INVENTORY_INIT/SUCCESS';
export const INVENTORY_INIT_FAILURE = 'inventory/INVENTORY_INIT/FAILURE';

export const INVENTORY_FIND_PRODUCTS_REQUEST = 'inventory/INVENTORY_FIND_PRODUCTS/REQUEST';
export const INVENTORY_FIND_PRODUCTS_SUCCESS = 'inventory/INVENTORY_FIND_PRODUCTS/SUCCESS';
export const INVENTORY_FIND_PRODUCTS_FAILURE = 'inventory/INVENTORY_FIND_PRODUCTS/FAILURE';

export const INVENTORY_SAVE_STOCKTAKING_REQUEST = 'inventory/INVENTORY_SAVE_STOCKTAKING/REQUEST';
export const INVENTORY_SAVE_STOCKTAKING_SUCCESS = 'inventory/INVENTORY_SAVE_STOCKTAKING/SUCCESS';
export const INVENTORY_SAVE_STOCKTAKING_FAILURE = 'inventory/INVENTORY_SAVE_STOCKTAKING/FAILURE';

export const INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS_REQUEST = 'inventory/INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS/REQUEST';
export const INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS_SUCCESS = 'inventory/INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS/SUCCESS';
export const INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS_FAILURE = 'inventory/INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS/FAILURE';

export const INVENTORY_UPDATE_PRODUCT_REQUEST = 'inventory/INVENTORY_UPDATE_PRODUCT/REQUEST';
export const INVENTORY_UPDATE_PRODUCT_SUCCESS = 'inventory/INVENTORY_UPDATE_PRODUCT/SUCCESS';
export const INVENTORY_UPDATE_PRODUCT_FAILURE = 'inventory/INVENTORY_UPDATE_PRODUCT/FAILURE';

export const INVENTORY_NEW_UNSAVED_CHANGE = 'inventory/INVENTORY_NEW_UNSAVED_CHANGE';
export const INVENTORY_RESET = 'inventory/INVENTORY_RESET';

export const INVENTORY_NEW_SEARCH = 'inventory/INVENTORY_NEW_SEARCH';



export function newSearch(){
    return {type: INVENTORY_NEW_SEARCH};
}

export function newUnsavedChanges(id){
    return {type: INVENTORY_NEW_UNSAVED_CHANGE, id}
}

export function reset(id){
    return {type: INVENTORY_RESET}
}

export function loadStockTakingsInProgress(account_id){
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.loadStockTakingsInProgress(account_id)
                .then(
                    stockTakings => {
                        dispatch(success(stockTakings));
                        resolve(stockTakings);
                    },
                    error => {
                        handleErrorCode(error,dispatch);
                        dispatch(failure(error));
                        reject();
                    }
                );
        });
    };

    function request() {
        return {type: INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS_REQUEST}
    }

    function success(stockTakings) {
        return {type: INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS_SUCCESS, stockTakings}
    }

    function failure(error) {
        return {type: INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS_FAILURE, error}
    }

}


export function saveStockTaking(){
    return (dispatch,getState) => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            const {stock_taking_id} = getState().inventory;
            api.saveStockTaking(stock_taking_id)
                .then(
                    () => {
                        dispatch(success());
                    },
                    error => {
                        handleErrorCode(error,dispatch);
                        dispatch(failure(error));
                        reject();
                    }
                );
        });
    };

    function request() {
        return {type: INVENTORY_SAVE_STOCKTAKING_REQUEST}
    }

    function success() {
        return {type: INVENTORY_SAVE_STOCKTAKING_SUCCESS}
    }

    function failure(error) {
        return {type: INVENTORY_SAVE_STOCKTAKING_FAILURE, error}
    }

}

export function update(id,count,counted,comment){
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            const {stock_taking_id} = getState().inventory;
            api.update(stock_taking_id,id,count,counted,comment)
                .then(
                    observation => {
                        dispatch(success(observation));
                        resolve(observation);
                    },
                    error => {
                        handleErrorCode(error,dispatch);
                        dispatch(failure(error));
                        reject();
                    }
                );
        });
    };

    function request() {
        return {type: INVENTORY_UPDATE_PRODUCT_REQUEST}
    }

    function success(observation) {
        return {type: INVENTORY_UPDATE_PRODUCT_SUCCESS, observation}
    }

    function failure(error) {
        return {type: INVENTORY_UPDATE_PRODUCT_FAILURE, error}
    }
}

export function find(code) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            const {stock_taking_id} = getState().inventory;
            api.find(code,stock_taking_id)
                .then(
                    products => {
                        dispatch(success(products));
                        resolve();
                    },
                    error => {
                        handleErrorCode(error,dispatch);
                        dispatch(failure(error));
                        resolve();
                    }
                );
        });
    };

    function request() {
        return {type: INVENTORY_FIND_PRODUCTS_REQUEST}
    }

    function success(products) {
        return {type: INVENTORY_FIND_PRODUCTS_SUCCESS, products}
    }

    function failure(error) {
        return {type: INVENTORY_FIND_PRODUCTS_FAILURE, error}
    }
}


export function init(account_id,stock_taking_id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.init(account_id,stock_taking_id)
                .then(
                    stockTaking => {
                        dispatch(success(stockTaking));
                        resolve(stockTaking);
                    },
                    error => {
                        handleErrorCode(error,dispatch);
                        dispatch(failure(error));
                        reject();
                    }
                );

        });
    };

    function request() {
        return {type: INVENTORY_INIT_REQUEST}
    }

    function success(stockTaking) {
        return {type: INVENTORY_INIT_SUCCESS, stockTaking}
    }

    function failure(error) {
        return {type: INVENTORY_INIT_FAILURE, error}
    }
}



function handleErrorCode(error, dispatch) {
    if(error === 401){
        //dispatch(logout());
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Inventory/reducer/actions.js